import { useSyncExternalStore } from 'react';
import { webDarkTheme, webLightTheme } from '@fluentui/react-components';
import { useMediaQuery } from '@mui/material';
import getTheme from '../themes/helper';
import DarkTheme from '../themes/DarkTheme';
import LightTheme from '../themes/LightTheme';
import { LOCAL_STORAGE_THEME_KEY, THEME_EVENT } from '../config';

let isDarkTheme = localStorage.getItem(LOCAL_STORAGE_THEME_KEY) === 'true';
const getCurrentTheme = () => isDarkTheme;

const listenForChanges = (onStorageChange: () => void) => {
  window.addEventListener(THEME_EVENT, onStorageChange);
  return () => window.removeEventListener(THEME_EVENT, onStorageChange);
};

const setDarkTheme = (value: boolean) => {
  isDarkTheme = value;

  if (value) {
    localStorage.setItem(LOCAL_STORAGE_THEME_KEY, 'true');
  } else {
    localStorage.removeItem(LOCAL_STORAGE_THEME_KEY);
  }

  window.dispatchEvent(new Event(THEME_EVENT));
};

function useAppTheme() {
  const isDarkThemeValue = useSyncExternalStore(listenForChanges, getCurrentTheme);
  const theme = isDarkThemeValue ? DarkTheme : LightTheme;

  return {
    isDarkTheme: isDarkThemeValue,
    muiTheme: getTheme(isDarkThemeValue),
    webTheme: isDarkThemeValue ? webDarkTheme : webLightTheme,
    updateDarkTheme: setDarkTheme,
    isMobile: useMediaQuery(theme.breakpoints.down(780)),
    isLaptop: useMediaQuery(theme.breakpoints.down('lg')),
    isWideScreen: useMediaQuery(theme.breakpoints.up(1600)),
  };
}

export default useAppTheme;
